import * as React from 'react';
export const alturacuSvg = React.forwardRef(function alturacuSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0075BE',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.645 6.716c.792 1.66 3.218 6.74 5.555 10.343.125.193.302.494.156.718-.067.096-.275.083-.817.012l-.255-.035c-.792-.11-2.541-.354-2.988-.286-.46.07-2.12.482-3.33.781-.617.153-1.118.277-1.28.312-.454.098-1.291.24-1.099-.195 1.113-2.527 2.721-9.374 3.211-11.463a55.35 55.35 0 0 1 .145-.609c.024-.11.057-.256.178-.291.11-.02.197.06.26.168.015.023.108.217.264.545Zm-5.06 10.154c.247-.383.633-.98.874-.628.144.228-.507 1.92-.878 2.576-.595 1.024-1.134 1.837-1.95 2.66-1.847 1.87-4.415 2.937-6.84 3.345l-.139.025c-.682.125-2.57.47-2.65-.621-.03-.404.48-.573 1.056-.763.455-.151.95-.315 1.25-.62.11-.112.23-.28.36-.464.283-.398.62-.874 1.055-1.04.314-.122.446.016.566.142.114.12.218.229.459.097.394-.217.84-.77 1.236-1.262.315-.39.598-.741.797-.85.415-.229.6-.06.786.108.192.176.386.352.84.09.451-.264.648-.718.841-1.164.147-.34.292-.675.546-.917.192-.182.35-.107.527-.024.278.131.6.283 1.16-.533.03-.044.066-.098.104-.158Zm10.478 4.754c-2.926-1.515-6.16-2.065-8.085-2.268-1.138-.081-1.043.021-.914.048 1.428.291 4.69.967 7.692 2.704.082.048.272.14.543.046.216-.069.33-.102.497-.151l.307-.092c.076-.023.244-.14-.04-.287Zm-9.531-1.898c1.288.256 4.228.97 7.16 2.748.211.143.074.244-.023.275-.344.111-.618.197-.972.308l-.396.124c-.225.096-.413-.042-.496-.104l-.002-.001c-1.587-1.355-4.256-2.559-5.617-3.04-.085-.022-.205-.056-.123-.215.088-.152.364-.116.469-.096Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M28.665 20.929c-2.606-.887-6.212-1.738-9.649-1.856-.3-.014-.61.027-.319.071 1.958.295 5.49.857 8.143 2.286.112.062.388.169.61.11l.533-.138c.246-.063.51-.131.708-.185.2-.059.183-.216-.026-.288Zm-13.003-.266c.062-.14.217-.238.398-.164.916.278 3.075 1.53 4.533 2.888.097.1.166.269-.068.35-.67.197-1.34.388-2.013.573l-.008.002a1.087 1.087 0 0 1-.87-.091c-1.304-.712-2.353-1.458-2.67-1.738-.07-.06-.109-.115-.036-.224.24-.437.45-.934.607-1.302.048-.111.09-.212.127-.294Z',
      fill: '#fff',
    }),
  );
});
alturacuSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var alturacu = {
  category: 'brand',
  colorable: false,
  name: 'alturacu',
  svg: alturacuSvg,
};
